import Vue from 'vue';
import Vuex from 'vuex';
import store from '@/store/index';
import {
  Mutation,
  Action,
  VuexModule,
  getModule,
  Module,
} from 'vuex-module-decorators';

Vue.use(Vuex);

export type EventForCalendar = {
  eventId: string;
  name: string;
  start: Date;
  end: Date;
  color: string;
  timed: boolean;
  monthlyDom?: HTMLElement;
  weeklyDom?: HTMLElement;
}

export type EventForGantChart = {
  eventId: string;
  id: string;
  label: string;
  rowId: string;
  time: {
    start: number;
    end: number;
  };
  style: {
    background: string;
    opacity: string;
  }
}

export type ShiftData = {
  eventId: string,
  temporary: boolean,
  calendar: EventForCalendar,
  gant: EventForGantChart
};

import GSTC from 'gantt-schedule-timeline-calendar';

import { uuid } from "uuidv4";

@Module({ dynamic: true, store, name: 'shift-data', namespaced: true })
class ShiftDataModule extends VuexModule {
  private GSTCID = GSTC.api.GSTCID;
  // TODO ダミーデータなので作り直す
  private shiftData: ShiftData[] = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31].map(elem => [elem, elem, elem, elem, elem, elem, elem]).reduce((acc, current) => {
    return acc.concat(current);
  }, []).map((temporaryIndex: number) => {
    const start = new Date();
    start.setDate(temporaryIndex)
    start.setHours(0 + 8, 0,0,0);
    const end = new Date();
    end.setDate(temporaryIndex)
    end.setHours(0 + 8 + 8, 0,0,0);
    const eventId = uuid();
    return {
      eventId,
      temporary: false,
      // カレンダービュー用のデータ
      calendar: {
        eventId,
        name: `Member ${temporaryIndex % 2 + 1}`,
        start,
        end,
        color: 'blue',
        timed: true
      },

      // ガントチャート用のデータ
      gant: {
        eventId,
        id: this.GSTCID(`${temporaryIndex}`),
        label: `Shift ${temporaryIndex}`,
        rowId: this.GSTCID(`${temporaryIndex}`),
        time:{
          start: start.getTime(),
          end: end.getTime()
        },
        style: {background: '#7fbfff', opacity: '0.7'}
      }
    }
  })
  private selectedElement?: Element;
  get eventsForCalendar() {
    return this.shiftData.map((event: ShiftData) => event.calendar);
  }
  get temporaryEventsForCalendar() {
    return this.shiftData.filter((event: ShiftData) => event.temporary).map((event: ShiftData) => event.calendar);
  }
  
  get eventsForGantChart() {
    return this.shiftData.filter((event: ShiftData) => !event.temporary).map((event: ShiftData) => event.gant);
  }
  get getSingleEventForCalendar() {
    return (eventId: string) => {
      return this.shiftData.find(shift => shift.eventId === eventId)?.calendar
    }
  }
  get getSingleEvent() {
    return (eventId: string) => {
      return this.shiftData.find(shift => shift.eventId === eventId)
    }
  }
  get getDateByEventId() {
    return (eventId: string) => {
      return this.shiftData.find(shift => shift.eventId === eventId)?.calendar.start.toISOString();
    }
  }
  @Action({rawError: true})
  public async addShiftAction(payload: {
    start: Date,
    end: Date,
    rowId?: string
  }) {
    const eventId = uuid();
    const tmp = this.addShift({
      ...payload,
      eventId,
      temporary: true
    })
    return eventId;
  }
  @Mutation
  public addShift(payload: {
    start: Date,
    end: Date,
    rowId?: string,
    eventId?: string,
    temporary?: boolean
  }) {
    const {
      start,
      end,
      rowId,
      eventId,
      temporary
    } = payload;
    const newEvent = {
      eventId: eventId || uuid(),
      temporary: temporary || false,
      // カレンダービュー用のデータ
      calendar: {
        eventId: eventId || uuid(),
        name: "担当未設定",
        start,
        end,
        color: 'blue',
        timed: true,
      },

      // ガントチャート用のデータ
      gant: {
        eventId: eventId || uuid(),
        id: `${this.shiftData.length + 1}`,
        label: "担当未設定",
        rowId: '1', // TODO rowIdの扱い
        time:{
          start: start.getTime(),
          end: end.getTime()
        },
        style: {background: '#7fbfff', opacity: '0.7'}
      }
    }
    
    return {newEvent, index: this.shiftData.push(newEvent)};
  }
  @Mutation
  public updateEvent(payload: {eventId?: string, start?: Date, end?: Date, name?: string, temporary?: boolean}) {
    const {
      eventId,
      start,
      end,
      name,
      temporary
    } = payload;
    this.shiftData.forEach(event => {
      if(event.eventId === eventId) {
        event.temporary = temporary === undefined ? event.temporary : temporary;
        event.calendar.start = start || event.calendar.start;
        event.calendar.end = end || event.calendar.end;
        event.gant.time.start = start ? start.getTime() : event.gant.time.start;
        event.gant.time.end = end ? end.getTime() : event.gant.time.end;
        event.calendar.name = name || event.calendar.name;
        event.gant.label = name || event.gant.label;
      }
    });
  }
  @Mutation
  public assignWeeklyCalendarDom(payload: {domElement: HTMLElement, eventId: string}) {
    const {
      domElement,
      eventId
    } = payload;
    this.shiftData.forEach(event => {
      if(event.eventId === eventId) {
        event.calendar.weeklyDom = domElement
      }
    });
  }
  @Mutation
  public assignMonthlyCalendarDom(payload: {domElement: HTMLElement, eventId: string}) {
    const {
      domElement,
      eventId
    } = payload;
    this.shiftData.forEach(event => {
      if(event.eventId === eventId) {
        event.calendar.monthlyDom = domElement
      }
    });
  }
  @Mutation
  public deleteShift(payload: {eventId: string}) {
    const { eventId } = payload;
    console.log(eventId)
    const index = this.shiftData.findIndex(shift => shift.eventId === eventId);
    console.log(index)
    this.shiftData.splice(index, 1);
  }
  @Mutation
  public sortShifts() {
    this.shiftData.sort((left: ShiftData, right: ShiftData) => {
      if(!left.temporary && right.temporary) {
        return 1
      } else if(left.temporary && !right.temporary) {
        return -1
      }
      if (left.calendar.start.getTime() > right.calendar.start.getTime()) {
        return 1;
      } else if (left.calendar.start.getTime() < right.calendar.start.getTime()) {
        return -1
      } else {
        return 0;
      }
    })
  }
  @Mutation
  public setSelectedElement(payload: {
    element: Element
  }) {
    this.selectedElement = payload.element;
  }
  @Mutation
  public removeSelectedElement() {
    delete this.selectedElement
  }
}

export const shiftDataStore = getModule(ShiftDataModule)